import type { NewsItem } from "@/types";

export const newsCategories = ["影史回顾", "幕后故事", "榜单盘点", "技术修复"];

export const news: NewsItem[] = [
  {
    id: "news-4k-restoration",
    title: "《银翼杀手》4K修复版重映：让雨水重新落在霓虹里",
    date: "2024-06-18",
    category: "技术修复",
    summary:
      "经过全新数字修复，这部1982年的科幻经典以更细腻的光影重回大银幕，雨夜的霓虹与烟尘仿佛触手可及。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20close%20up%20of%20a%20vintage%20film%20reel%20and%20editing%20equipment%20in%20a%20dark%20editing%20room%20lit%20by%20warm%20amber%20light%2C%20steam%20and%20dust%20particles%2C%20retro%20technology%20mood%2C%20vintage%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20no%20text%20no%20words&width=800&height=500&seq=nw-restoration-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "当修复团队第一次把扫描仪对准那份尘封已久的底片时，他们发现画面里藏着远比想象中更多的细节。雨滴落在街道上的每一圈涟漪、霓虹招牌在湿润空气里的散射，都被重新唤醒。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rainy%20neon%20city%20street%20at%20night%20reflected%20in%20puddles%2C%20atmospheric%20steam%2C%20warm%20amber%20and%20teal%20lighting%2C%20vintage%20film%20grain%2C%20artistic%20illustration%2C%20no%20text%20no%20words&width=800&height=500&seq=nw-restoration-02&orientation=landscape",
        caption: "修复后的雨夜街区，色彩的层次被重新还原。",
      },
      {
        type: "p",
        text: "修复并非简单的“提高清晰度”。团队需要对每一帧进行色彩校正与颗粒管理，既要保留胶片原有的质感，又不能让它显得陈旧。尤其在那些只有霓虹和雨水的夜景里，稍有不慎就会失去原作的湿润与朦胧。",
      },
      {
        type: "quote",
        text: "我们要做的不是让它变成一部新电影，而是让观众第一次真正看清它本来的样子。",
      },
      {
        type: "p",
        text: "随着重映档期公布，不少影迷表示这是他们第一次有机会在大银幕上看到这部作品。对于一部曾经在票房上失意的电影来说，这份迟到四十年的回响，本身就是一段值得记录的影史。",
      },
    ],
  },
  {
    id: "news-80s-soundtrack",
    title: "合成器的黄金年代：为什么80年代电影配乐至今仍在回响",
    date: "2024-05-30",
    category: "影史回顾",
    summary:
      "从电子鼓点到悠长弦乐，80年代的电影配乐塑造了一代人的听觉记忆，也在今天的影视与音乐里持续被采样。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20retro%20synthesizer%20keyboard%20and%20drum%20machine%20in%20a%20dim%20studio%20lit%20with%20warm%20amber%20and%20teal%20light%2C%20neon%20accents%2C%20vintage%20eighties%20mood%2C%20film%20grain%20texture%2C%20no%20text%20no%20words&width=800&height=500&seq=nw-synth-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "如果用一个声音来代表80年代，那多半是合成器。它既能在追逐戏里制造心跳加速的节拍，也能在情感段落里铺开一片辽阔而忧郁的音场。",
      },
      {
        type: "p",
        text: "那个年代，电子乐器第一次真正走入大众视野。创作者们不再依赖庞大的管弦乐团，而是用几台键盘和鼓机，就能搭建出整部电影的声音世界。这种“轻装上阵”的方式，反而催生出许多大胆而前卫的实验。",
      },
      {
        type: "quote",
        text: "合成器让一个人也能拥有一整支乐队，而这正是那个年代最迷人的地方。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20golden%20waveforms%20and%20equalizer%20bars%20floating%20over%20a%20dark%20gradient%20background%2C%20warm%20orange%20and%20teal%20glow%2C%20retro%20music%20mood%2C%20film%20grain%2C%20no%20text%20no%20words&width=800&height=500&seq=nw-synth-02&orientation=landscape",
        caption: "声音的可视化，让配乐的情绪变得可以“看见”。",
      },
      {
        type: "p",
        text: "如今，许多当代影视与音乐作品仍在使用那个年代的音色。它不只是一种怀旧，更是一种被反复验证过的、能够直击情绪的听觉语言。",
      },
    ],
  },
  {
    id: "news-teen-movies",
    title: "青春的叛逆与温柔：重看80年代青少年电影",
    date: "2024-04-22",
    category: "榜单盘点",
    summary:
      "那些发生在走廊、球场与停车场里的故事，为什么依然能让今天的观众找到共鸣？",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20retro%20empty%20high%20school%20lockers%20and%20corridor%20at%20golden%20hour%20with%20dust%20in%20the%20air%2C%20nostalgic%20mood%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20no%20text%20no%20words&width=800&height=500&seq=nw-teen-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "80年代的青少年电影之所以特别，是因为它们第一次认真地对待了“少年人的烦恼”。在那些看似轻松的故事背后，藏着对家庭、身份与未来的真实焦虑。",
      },
      {
        type: "p",
        text: "这些电影往往没有惊天动地的奇观，场景也无非是学校、购物中心和郊外公路。但正是这种日常感，让观众更容易把自己的影子投进去。",
      },
      {
        type: "quote",
        text: "它们相信，少年人的心事，和成年人的心事一样值得被认真讲述。",
      },
      {
        type: "p",
        text: "时至今日，那些关于友谊、暗恋与自我认同的桥段依然被不断引用。它们提醒我们，成长的主题从未过时，只是换了不同的嗓音在讲述。",
      },
    ],
  },
  {
    id: "news-practical-effects",
    title: "不用电脑怎么做怪兽？80年代特效的笨办法与真功夫",
    date: "2024-03-15",
    category: "幕后故事",
    summary:
      "在数字特效普及之前，电影人靠模型、化妆与机械装置，创造出令人信服的世界。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20retro%20practical%20effects%20workshop%20with%20miniature%20models%2C%20paint%20brushes%20and%20warm%20workbench%20light%2C%20artisan%20craftsmanship%20mood%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20no%20text%20no%20words&width=800&height=500&seq=nw-effects-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "那个年代，想要让观众相信一个不存在的世界，靠的是实打实的手艺。微缩模型、机械道具和厚重的化妆，都是创作者与物理世界的一场硬碰硬。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Cinematic%20close%20up%20of%20a%20detailed%20miniature%20spaceship%20model%20being%20lit%20on%20a%20set%20with%20warm%20amber%20lights%20and%20teal%20shadows%2C%20retro%20workshop%20mood%2C%20film%20grain%20texture%2C%20no%20text%20no%20words&width=800&height=500&seq=nw-effects-02&orientation=landscape",
        caption: "一台被反复打磨的模型，往往要经得起数周的拍摄。",
      },
      {
        type: "p",
        text: "虽然工序繁琐、成本高昂，但这种“看得见摸得着”的质感，至今仍被许多观众认为无法替代。毕竟，真实的灯光打在真实的表面上，那种反射是人类的眼睛天生就信任的。",
      },
      {
        type: "p",
        text: "今天，很多创作者依然会在数字特效之外，保留一部分实拍与模型镜头。它们像是一种致敬，也像是一种对品质的坚持。",
      },
    ],
  },
  {
    id: "news-cult-classics",
    title: "从票房失意到影史经典：那些被时间平反的80年代电影",
    date: "2024-02-08",
    category: "影史回顾",
    summary:
      "有些电影在首映时无人问津，却在多年后成为无数人心中的神作。时间，往往是最公正的评论家。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20retro%20empty%20movie%20theater%20with%20red%20velvet%20seats%20and%20a%20warm%20projector%20beam%20cutting%20through%20dust%2C%20nostalgic%20cinema%20mood%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20no%20text%20no%20words&width=800&height=500&seq=nw-cult-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "票房的成功与作品的价值，从来不总是同一件事。80年代留下了不少这样的例子：它们在影院里匆匆退场，却在录像带、电视重播与影迷的讨论中慢慢复活。",
      },
      {
        type: "p",
        text: "一部电影能否被时间留下，往往取决于它是否触动了某些难以言说的东西。可能是独特的世界观，可能是克制而深情的表达，也可能只是一场让人久久难忘的结尾。",
      },
      {
        type: "quote",
        text: "观众的耐心可以迟到，但真诚的创作不会被真正埋没。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Cinematic%20retro%20stack%20of%20old%20vhs%20tapes%20and%20film%20cans%20on%20a%20wooden%20shelf%20lit%20with%20warm%20amber%20light%2C%20nostalgic%20mood%2C%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20no%20text%20no%20words&width=800&height=500&seq=nw-cult-02&orientation=landscape",
        caption: "录像带时代，让许多被忽略的作品重新被看见。",
      },
      {
        type: "p",
        text: "对今天的创作者而言，这或许也是一种安慰：认真讲好的故事，终会等到属于它的观众。",
      },
    ],
  },
  {
    id: "news-director-legacy",
    title: "作者导演的崛起：80年代如何塑造了现代电影的语法",
    date: "2024-01-12",
    category: "幕后故事",
    summary:
      "在商业与艺术之间，一批导演用自己的个人印记，重新定义了主流电影的叙事与视觉。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20retro%20film%20director%20chair%20and%20megaphone%20on%20an%20empty%20set%20lit%20with%20warm%20amber%20lights%20and%20teal%20shadows%2C%20nostalgic%20mood%2C%20vintage%20film%20grain%20texture%2C%20no%20text%20no%20words&width=800&height=500&seq=nw-director-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "80年代是作者导演真正走进主流的年代。他们既能在商业体系里工作，又能把强烈的个人风格渗进每一帧画面。",
      },
      {
        type: "p",
        text: "无论是冷峻的科幻、热血的冒险，还是细腻的家庭故事，观众开始意识到：一部电影的“作者”是谁，本身就是值得关注的理由。",
      },
      {
        type: "quote",
        text: "当导演的名字成为一种期待，电影就拥有了超越单部作品的重量。",
      },
      {
        type: "p",
        text: "这种对个人表达的重视，直接影响了之后几十年的电影创作。今天的许多类型片里，我们仍能看到那个年代留下的语法与野心。",
      },
    ],
  },
];

export function getNewsById(id: string): NewsItem | undefined {
  return news.find((n) => n.id === id);
}